/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { mapObject, constant, identity } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getSelectableItemStyles } from '../styles';

class SelectableItem extends React.PureComponent {
  handleKeyDown = (event) => {
    if ((event.keyCode === 13) || (event.keyCode === 32)) {
      this.handleClick();
    }
  };

  handleClick = () => {
    const {
      id, siteMapId, siteMapAvailable, onClick,
    } = this.props;

    if (onClick) {
      onClick({ id, siteMapId, siteMapAvailable });
    }
  };

  render() {
    const {
      classes,
      'aria-label': ariaLabel,
      isSelected,
      children,
      ariaItemSize,
      ariaItemIndex,
      className,
      showWarning,
      isNewFeature,
      i18n,
    } = this.props;

    const rootClass = classnames([
      classes.selectableButton,
      `campaign-objective-button${isSelected ? ' selected' : ''}`,
      className,
    ]);

    return (
      <div
        onMouseOver={() => showWarning(true)}
        onFocus={showWarning}
        className={rootClass}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        aria-label={ariaLabel}
      >
        <input
          type="radio"
          tabIndex="0"
          className="shared-radio"
          aria-checked={isSelected}
          checked={isSelected}
          value={ariaLabel}
          aria-setsize={ariaItemSize}
          aria-posinset={ariaItemIndex}
          aria-label={isNewFeature
            ? `${i18n.getString(_TL_('New.'))} ${ariaLabel}`
            : ariaLabel}
        />
        {children}
      </div>
    );
  }
}

SelectableItem.propTypes = {
  classes: PropTypes.shape(mapObject(
    getSelectableItemStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  id: PropTypes.string.isRequired,
  siteMapId: PropTypes.string,
  siteMapAvailable: PropTypes.func,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  'aria-label': PropTypes.string,
  isSelected: PropTypes.bool,
  ariaItemSize: PropTypes.number.isRequired,
  ariaItemIndex: PropTypes.number.isRequired,
  className: PropTypes.string,
  showWarning: PropTypes.func,
  isNewFeature: PropTypes.bool,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }),
};

SelectableItem.defaultProps = {
  onClick: null,
  siteMapId: '',
  siteMapAvailable: null,
  'aria-label': '',
  isSelected: false,
  className: '',
  showWarning: identity,
  isNewFeature: false,
  i18n: {
    getString: text => text,
  },
};

export const StyledSelectableItem = withDefaultStyles(SelectableItem, getSelectableItemStyles);
